import { render } from "./ViewUsers.vue?vue&type=template&id=3da5380d"
import script from "./ViewUsers.vue?vue&type=script&lang=ts"
export * from "./ViewUsers.vue?vue&type=script&lang=ts"
script.render = render

export default script